(ns dre.pages.admin.survey.events
  (:require
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.fx :as-alias dre.fx]
   [dre.network :as-alias network]
   [dre.pages.admin.survey.db :refer [init-db]]
   [re-frame.core :as rf]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))

(def db-path [:pages :admin :survey])

; vvv EVENTS vvv

(rf/reg-event-fx
 ::init
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [_ _]
  {:db init-db}))

(rf/reg-event-fx
 ::download-csv
 (fn-traced
  [_ _]
  {::network/request [{:endpoint :admin/surveys.export-csv}
                      {:response-content-type :text
                       :on-success [::download-csv-ok]}]}))

(rf/reg-event-fx
 ::download-csv-ok
 [rf/trim-v]
 (fn-traced
  [_ [{::fetch-fx/keys [response]}]]
  {::dre.fx/download {:content (:body response)
                      :filename "nps_survey_results.csv"
                      :mimetype "text/csv"}}))

; ---

; vvv SUBS vvv
